import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
// public/locales/{language}/translation.json

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en-US",
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // react already safe from xss
    },
  });

export default i18n;
